export const SUCCESS_GET_ALLCLIENTEVENTS = 'SUCCESS_GET_ALLCLIENEVENTS';
export const FAILED_GET_ALLCLIENTEVENTS = 'FAILED_GET_ALLCLIENTEVENTS';
export const SUCCESS_CREATE_CLIENTEVENT = 'SUCCESS_CREATE_CLIENTEVENT';
export const FAILED_CREATE_CLIENTEVENT = 'FAILED_CREATE_CLIENTEVENT';
export const SUCCESS_UPDATE_CLIENTEVENT = 'SUCCESS_UPDATE_CLIENTEVENT';
export const FAILED_UPDATE_CLIENTEVENT = 'FAILED_UPDATE_CLIENTEVENT';
export const SUCCESS_DELETE_CLIENTEVENT = 'SUCCESS_DELETE_CLIENTEVENT';
export const FAILED_DELETE_CLIENTEVENT = 'FAILED_DELETE_CLIENTEVENT';



// WEBPACK FOOTER //
// ./src/state/constants/clientEventConstants.js